<script setup lang="ts">
/**
 * Footer V2 — Patrocinadores oficiais
 *
 * Reusa a mesma fonte do footer legado: useAppearanceStore().appearance.sponsorships.
 * Cada item traz { id, name, icon, page_url }, sendo `icon` resolvido por
 * getUrlForApiImage (URL absoluta da API). Hide externo respeita useLinks().
 */

const appearanceStore = useAppearanceStore();
const { hideExternalLinks } = useLinks();

const sponsors = computed(() => appearanceStore.appearance.sponsorships ?? []);
const hasSponsors = computed(() => sponsors.value.length > 0);
</script>

<template>
  <div
    v-if="hasSponsors"
    class="footer-v2-sponsors"
  >
    <p class="footer-v2-sponsors__title">Patrocinadores oficiais:</p>

    <div class="footer-v2-sponsors__items">
      <template
        v-for="sponsor in sponsors"
        :key="sponsor.id"
      >
        <a
          v-if="!hideExternalLinks && sponsor.page_url"
          :aria-label="sponsor.name"
          class="footer-v2-sponsors__link"
          :href="sponsor.page_url"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            :alt="sponsor.name"
            class="footer-v2-sponsors__img"
            decoding="async"
            loading="lazy"
            :src="getUrlForApiImage(sponsor.icon) || ''"
          />
        </a>

        <img
          v-else
          :alt="sponsor.name"
          class="footer-v2-sponsors__img"
          decoding="async"
          loading="lazy"
          :src="getUrlForApiImage(sponsor.icon) || ''"
        />
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.footer-v2-sponsors {
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;

  /* Desktop:
       padding 20px 36px / gap 40px (texto à esquerda + items à direita
       em row) / border-radius 9px / border branca 10%. */
  @media (min-width: 1024px) {
    flex-direction: row;
    padding: 20px 36px;
    gap: 40px;
    border-radius: 9px;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__title {
    margin: 0;
    color: rgba(255, 255, 255, 0.5); // #FFFFFF80
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
  }

  &__items {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
  }

  &__link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  &__img {
    /* Replica o footer legado (mobile): caixa quadrada 80x80
       com object-contain — uniformiza visualmente logos de
       proporções diferentes (Maringá 1/1, Bahia 5/6 etc). */
    display: block;
    width: 80px;
    height: 80px;
    object-fit: contain;
  }
}
</style>
